// Import icons
/*
import gettingStartedIcon from "../../assets/images/valkyrie_service.svg";
import userManagementIcon from "../../assets/images/Users_icon.svg";
import runningScanIcon from "../../assets/images/VULNERAB_Dashboard.svg";
import viewingResultsIcon from "../../assets/images/report_mode.svg";
import remediationModeIcon from "../../assets/images/report_mode.svg";
import pqrToolsIcon from "../../assets/images/menu_icons/Quantum_IconMain.svg";
import apiIntegrationsIcon from "../../assets/images/menu_icons/WebTechnologies_Dashboard.svg";
*/

import gettingStartedIcon from "../../../assets/images/Identify_Valkyrie.svg";
import userManagementIcon from "../../../assets/images/Identify_Valkyrie.svg";
import runningScanIcon from "../../../assets/images/Identify_Valkyrie.svg";
import viewingResultsIcon from "../../../assets/images/Identify_Valkyrie.svg";
import remediationModeIcon from "../../../assets/images/Identify_Valkyrie.svg";
import pqrToolsIcon from "../../../assets/images/Identify_Valkyrie.svg";
import apiIntegrationsIcon from "../../../assets/images/Identify_Valkyrie.svg";


export const platformSubcategories = [
  {
    id: "getting-started",
    title: "Getting Started",
    icon: gettingStartedIcon,
    sections: [
      //{ id: "platform-overview", title: "Platform Overview" },
      //{ id: "first-login", title: "First Login" },
      //{ id: "navigation", title: "Navigation" },
      //{ id: "dashboard", title: "Dashboard" }
    ]
  },
  {
    id: "user-management",
    title: "User Management",
    icon: userManagementIcon,
    sections: [
      //{ id: "user-roles", title: "User Roles" },
      //{ id: "adding-users", title: "Adding Users" },
      //{ id: "permissions", title: "Permissions" },
      //{ id: "profile-settings", title: "Profile Settings" }
    ]
  },
  {
    id: "running-scans",
    title: "Running Scans",
    icon: runningScanIcon
  },
  {
    id: "viewing-results",
    title: "Viewing Results",
    icon: viewingResultsIcon
  },
  {
    id: "remediation-mode",
    title: "Remediation Mode",
    icon: remediationModeIcon
  },
  {
    id: "pqr-tools",
    title: "PQR Tools",
    icon: pqrToolsIcon
  },
  {
    id: "api-integrations",
    title: "API & Integrations",
    icon: apiIntegrationsIcon
  }
];